// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwList from 'viewmodel/AwListViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desUpdateLibraryService', () => import('js/desUpdateLibraryService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "data": {
        "selectedUsers": null
    },
    "lifecycleHooks": {
        "onUpdate": {
            "observers": [
                "props.accsessionid",
                "props.collaborationspaceid",
                "props.libraryid"
            ]
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        }
    },
    "dataProviders": {
        "performSearchForUsers": {
            "action": "getUsers",
            "response": "{{data.searchResults}}",
            "totalFound": "{{data.totalFound}}",
            "selectionModelMode": "multiple"
        }
    },
    "actions": {
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "revealUsers": {
            "actionType": "dataProvider",
            "method": "performSearchForUsers"
        },
        "getUsers": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}",
                            "searchInput": "{{data.eventData.searchInput}}"
                        },
                        "query": "query ListCollabSpaceMembers($listInput: ListInput) {listCollabSpaceMembers(listInput: $listInput) }",
                        "variables": {
                            "listInput": {
                                "searchOptions": {
                                    "skip": 0,
                                    "limit": 50,
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "searchResults": "data.data.listCollabSpaceMembers.filterObj",
                "totalFound": "data.data.listCollabSpaceMembers.totalFound"
            },
            "events": {
                "success": [
                    {
                        "name": "searchResultsSuccess",
                        "condition": "searchResults.hasError === false",
                        "eventData": {
                            "eventName": "searchResultsSuccess",
                            "eventData": "{{searchResults}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "clearSeachBox": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "clearSeachBoxEvent"
                    }
                ]
            }
        },
        "storeUsers": {
            "actionType": "JSFunction",
            "method": "storeUserData",
            "inputData": {
                "data": "{{data}}",
                "selectedUsers": "{{parameters.eventData}}"
            },
            "outputData": {
                "selectedObjects": "selectedAllUsers"
            },
            "events": {
                "success": [
                    {
                        "name": "selectedUsersSuccess",
                        "eventData": {
                            "eventData": "{{selectedObjects}}"
                        }
                    }
                ]
            },
            "deps": "js/desUpdateLibraryService"
        }
    },
    "onEvent": [
        {
            "eventId": "searchInitiated",
            "action": "revealUsers",
            "cacheEventData": true
        },
        {
            "eventId": "performSearchForUsers.selectionChangeEvent",
            "action": "storeUsers",
            "inputArgs": {
                "eventName": "performSearchForUsers.selectionChangeEvent",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "selectedUsersSuccess",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "selectedUsersSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        }
    ],
    "_viewModelId": "DesShareLibrarySearchResultsForUsers",
    "_uniqueViewModelId": "DesShareLibrarySearchResultsForUsers",
    "ctx": {}
};

    /*
    <aw-list dataprovider="data.dataProviders.performSearchForUsers">
    <aw-default-cell vmo="item"></aw-default-cell>
</aw-list>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwList dataprovider={dataProviders.performSearchForUsers} showDropArea={null} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>        <AwDefaultCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
        </AwDefaultCell></> } }
    </AwList>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;